import React, { useEffect, useState } from 'react'
import { garmentState, onGarmentChange } from '../lib/garment/garmentAttach.js'
import { describeGarmentIndicator } from '../lib/garment/garmentIndicatorState.js'

// Palette tokens only — a hex literal here is a lint failure by design
// (paletteEnforcement.test.mjs), and these are the same four tones the sibling
// HeadTrackIndicator / FaceTrackIndicator pills use.
const TONE_COLOR = {
  neutral: 'var(--m-fg-2)',
  ok: 'var(--m-online)',
  warn: 'var(--m-warn)',
  danger: 'var(--m-danger)',
}

/**
 * GarmentIndicator — the Marvelous-garment viewport pill (ENG-1108).
 *
 * Self-hides unless `?garment=` asked for one, so an ordinary page load is
 * untouched. When a garment IS on the avatar the pill is not decoration: this
 * pass persists nothing (there is no garment asset kind on the server yet), so
 * the pill is the only thing on screen that says the character is wearing a
 * LOCAL PREVIEW which will vanish on reload. It also carries the two numbers
 * a bad import hides behind a plausible render — how much of the mesh failed
 * to bind, and whether the garment is even the right size for this body.
 *
 * All wording and tone live in garmentIndicatorState.js so they can be
 * asserted without a DOM.
 */
export default function GarmentIndicator() {
  const [state, setState] = useState(garmentState)
  useEffect(() => onGarmentChange(setState), [])

  const view = describeGarmentIndicator(state)
  if (!view) return null
  const color = TONE_COLOR[view.tone] ?? TONE_COLOR.neutral

  return (
    <div
      data-testid="garment-indicator"
      data-phase={state.phase}
      data-tone={view.tone}
      style={{
        position: 'absolute', top: 44, right: 12, zIndex: 30,
        maxWidth: 320,
        background: 'color-mix(in srgb, var(--m-panel) 90%, transparent)',
        border: `1px solid ${color}`,
        borderRadius: 4, padding: '4px 10px',
        color,
        fontFamily: 'var(--m-font)', fontSize: 11, lineHeight: 1.5,
        pointerEvents: 'none',
      }}
    >
      <div>{view.label}</div>
      {view.detail && (
        <div style={{ color: 'var(--m-fg-2)', fontSize: 10 }}>{view.detail}</div>
      )}
    </div>
  )
}
